<div class="login-logo-wrapper">
  <img
    class="login-logo"
    src="assets/static/inpool__white.svg"
    alt="InPool Logo" />
</div>
<div
  class="login-form"
  *ngIf="!isLoggedIn() && !(accountService.twoFactorAuthRequired | async)">
  <div
    *ngIf="loginStep === LoginStepperEnum.PASSWORD"
    class="login-form__back-link"
    (click)="goToEmailStep()">
    <mat-icon svgIcon="arrow-left"></mat-icon>
    {{ "back" | i18n | titlecase }}
  </div>
  <h1 class="login-form__title">
    {{ ("login" | i18n) || "login" | titlecase }}
  </h1>
  <ng-container
    *ngIf="
      loadingCancelled || (!isLoadingAdfsLogin && !(msalLoading$ | async));
      else loadingAdfsLogin
    ">
    <ng-container *ngIf="loginStep === LoginStepperEnum.EMAIL">
      <form
        *ngIf="loginForm"
        class="login-form__form"
        [formGroup]="loginForm"
        (ngSubmit)="submitLoginStep()">
        <mat-form-field>
          <mat-label>{{ ("email" | i18n) || "Email" }}</mat-label>
          <input
            #emailInput
            matInput
            type="email"
            autofocus
            name="user"
            autocomplete="email"
            formControlName="email"
            data-cy="login-email"
            email="true" />

          <mat-error
            class="input-error"
            *ngIf="loginForm?.controls?.email?.errors">
            {{
              loginForm?.controls?.email?.errors?.required
                ? ("requiredField" | i18n) || "Pflichtfeld"
                : loginForm?.controls?.email?.errors?.email
                ? ("emailInvalid" | i18n)
                : ""
            }}
          </mat-error>
        </mat-form-field>
        <button
          *ngIf="!(accountService.isLoading | async)"
          mat-button
          color="primary"
          type="submit"
          name="login"
          class="mat-button-block login-form__login-button"
          value="Login"
          data-cy="login-continue">
          <div class="login-form__login-button-content">
            {{ ("continue" | i18n) || "Weiter" | titlecase }}
          </div>
        </button>
        <input
          class="d-none"
          type="password"
          name="password"
          autocomplete="current-password"
          formControlName="password" />
      </form>
    </ng-container>

    <ng-container *ngIf="loginStep === LoginStepperEnum.PASSWORD">
      <form
        *ngIf="loginForm"
        class="login-form__form"
        [formGroup]="loginForm"
        (ngSubmit)="submitLoginStep()">
        <input
          class="d-none"
          matInput
          type="email"
          autofocus
          name="user"
          autocomplete="email"
          formControlName="email"
          data-cy="login-email"
          formControlName="email"
          email="true" />
        <div
          class="login-form__entered-email-value"
          (click)="goToEmailStep()">
          {{ this.loginForm.controls.email.value }}
          <mat-icon
            class="edit-email-icon"
            svgIcon="pencil-outline"></mat-icon>
        </div>
        <mat-form-field>
          <mat-label>{{
            ("password" | i18n) || "password" | titlecase
          }}</mat-label>
          <input
            #passwordInput
            matInput
            [type]="showPassword ? 'text' : 'password'"
            name="password"
            autocomplete="current-password"
            data-cy="login-password"
            formControlName="password" />
          <button
            matSuffix
            matIconButton
            class="password-toggle-button"
            (click)="showPassword = !showPassword"
            aria-label="show password">
            <mat-icon svgIcon="eye-outline"></mat-icon>
          </button>
          <mat-error
            class="input-error"
            *ngIf="
              loginForm?.controls?.password?.errors?.required &&
              (passwordSubmitted ||
                loginForm?.controls?.password?.dirty ||
                loginForm?.controls?.password?.touched)
            ">
            {{ ("requiredField" | i18n) || "Pflichtfeld" }}
          </mat-error>
        </mat-form-field>
        <a
          class="login-form__forgot-password-link"
          [class.no-error]="
            !(
              loginForm?.controls?.password?.errors?.required &&
              (passwordSubmitted ||
                loginForm?.controls?.password?.dirty ||
                loginForm?.controls?.password?.touched)
            )
          "
          data-cy="forgot-password-button"
          [queryParams]="{ email: this.loginForm.controls.email.value }"
          [routerLink]="['/forgot-password']">
          {{ ("forgotPassword" | i18n) || "forgot password?" }}
        </a>

        <button
          *ngIf="!(accountService.isLoading | async)"
          mat-button
          color="primary"
          type="submit"
          name="login"
          class="mat-button-block login-form__login-button"
          value="Login"
          data-cy="login-submit">
          <div class="login-form__login-button-content">
            {{ ("login" | i18n) || "login" | titlecase }}
          </div>
        </button>
      </form>
    </ng-container>

    <div class="d-flex justify-content-center">
      <mat-progress-spinner
        *ngIf="accountService.isLoading | async"
        [color]="'primary'"
        [mode]="'indeterminate'"
        diameter="20"
        class="loadingSpinner">
      </mat-progress-spinner>
    </div>
  </ng-container>
  <ng-template #loadingAdfsLogin>
    <div class="login-form__loading-state">
      <div class="login-form__loading-content">
        <mat-spinner diameter="34"></mat-spinner>
        <p class="login-form__loading-hint">
          {{ ("loggingIn" | i18n) || "Logging in..." }}
        </p>
      </div>
      <button
        mat-button
        color="primary"
        class="mat-button-block login-form__login-button"
        (click)="loadingCancelled = true">
        <div class="login-form__login-button-content">
          {{ ("cancel" | i18n) || "Cancel" }}
        </div>
      </button>
    </div>
  </ng-template>
</div>
<app-two-factor-authentication
  [authData]="authData"
  *ngIf="
    accountService.twoFactorAuthRequired | async
  "></app-two-factor-authentication>
